import { ChangeDetectionStrategy, Component, HostListener, inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Tag } from "@vp/models";

export interface DialogData {
  tag: Tag;
  planName: string;
  mode: "add" | "edit";
}

@Component({
  selector: "vp-add-cost-pricing-plan-dialog",
  templateUrl: "./add-cost-pricing-plan-dialog.component.html",
  styleUrls: ["./add-cost-pricing-plan-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddCostPricingPlanDialogComponent {
  data = inject<DialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<AddCostPricingPlanDialogComponent>>(MatDialogRef);
  readonly formBuilder = inject(UntypedFormBuilder);

  form!: UntypedFormGroup;

  @HostListener("window:keyup.esc") onKeyUp() {
    this.close(false);
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  constructor() {
    const data = this.data;
    const formBuilder = this.formBuilder;

    this.form = formBuilder.group({
      planName: [data.planName ?? null, Validators.required]
    });
  }

  onCancel = () => {
    this.close(false);
  };

  onSave = () => {
    this.close(true);
  };

  close(save: boolean) {
    if (save && this.form.valid) {
      this.dialogRef.close(this.form.getRawValue().planName);
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.dialogRef.close();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.dialogRef.close();
        }
      }
    }
  }
}
